import api from "../Api";

export const loginUser = async ({ email, password }, login) => {
    // login is the context login function
    await login({ email, password });
};

export const registerUser = async (formData) => {
    const { userId, ...updates } = formData;
    if (userId) {
        return api.put(`/users/${userId}/register`, updates);
    } else {
        return api.post("/users/register", updates);
    }
};

export const fetchInviteInfo = async (code) => {
    return api.get(`/users/invite/info/${code}`);
};

export const fetchKvKInfo = async (kvkNumber) => {
    return api.get(`/kvk/lookup/${kvkNumber}`);
};

